import React from "react";
import { Helmet } from "react-helmet";
import BeginSection from "../../components/blocks/BeginSection";
import PartnerHeader from "./components/PartnerHeader";
import PartnersListingSection from "./components/PartnersListingSection";
import SiteFooter from "../../components/layout/SiteFooter";

const Partners = () => {
  return (
    <div>
      <Helmet>
        <title>Utiva | About Us</title>
      </Helmet>

      <PartnerHeader />

      <PartnersListingSection />

      <BeginSection
        title={
          <>
            Let’s build the future{" "}
            <span className="text-gradient">tech Talents</span> together
          </>
        }
        isExternalLink
        btnTitle="Get Started"
        btnLink={"https://forms.aweber.com/form/59/2078612059.htm"}
      />

      <SiteFooter />
    </div>
  );
};

export default Partners;
